import { Injectable } from '@angular/core';


@Injectable()
export class FaqCommonService {

      constructor() {
      }

      isOpenFn(params: Array<any>) {
            const isOpenArray: Array<any> = [];
            const bb = 'fa fa-angle-down';
            params.forEach((item, index) => {

                  isOpenArray.push({
                        isOpen: bb
                  });

                  isOpenArray[index].text = [];
                  item.text.forEach(element => {
                        isOpenArray[index].text.push({
                              isOpen: bb
                        });
                  });

            });

            return isOpenArray;
      }


      closeArrow(params: Array<any>, index: number, childIndex: number) {

            const aa = 'fa fa-angle-up';
            const bb = 'fa fa-angle-down';

            console.log(index, childIndex)
            if (childIndex !== undefined) {

                  const lastValue = params[index].text[childIndex].isOpen;
                  params[index].text[childIndex].isOpen = (lastValue === aa) ? bb : aa;

            } else {
                  let lastValue;
                  if (index !== undefined) {
                        lastValue = params[index].isOpen;
                  }
                  params.forEach((item) => {
                        item.isOpen = bb;
                  });
                  if (index !== undefined) {
                        params[index].isOpen = (lastValue === aa) ? bb : aa;
                  }

            }

            console.log('params', params)
      }
}



// WEBPACK FOOTER //
// ./src/app/pages/faq/faq.common.service.ts